module.exports = __webpack_public_path__ + "images/tft-trigger-banner-bg.webp";